module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./AssociateAttrView.jsx"));
	}, "AssociateAttrView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AssociateAttrView!./src/pages/RoleMgmt/AssociateAttr/AssociateAttrView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=AssociateAttrView!./src/pages/RoleMgmt/AssociateAttr/AssociateAttrView.jsx
// module chunks = 43